import { createStore, applyMiddleware, compose } from 'redux';
import { batchDispatchMiddleware } from 'redux-batched-actions';
import createSagaMiddleware, { END } from 'redux-saga';
import createRootReducer from './rootReducer';

type StoreParams = {
    initialState?: { [key: string]: any };
    middleware?: any[];
};

const sagaMiddleware = createSagaMiddleware();

export const configureStore = ({ initialState, middleware = [] }: StoreParams) => {
    const devtools =
        typeof window !== 'undefined' &&
        typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ actionsBlacklist: [] });

    const composeEnhancers = devtools || compose;

    const store: any = createStore(
        createRootReducer(),
        initialState,
        composeEnhancers(
            applyMiddleware(...[batchDispatchMiddleware, sagaMiddleware].concat(...middleware))
        )
    );

    if (process.env.NODE_ENV !== 'production' && module.hot) {
        if (module.hot) {
            module.hot.accept('./rootReducer', () =>
                store.replaceReducer(require('./rootReducer').default)
            );
        }
    }

    // Extensions
    store.runSaga = sagaMiddleware.run;
    store.closeSagas = () => store.dispatch(END);
    store.injectedReducers = {}; // Reducer registry
    store.injectedSagas = {}; // Saga registry

    return store;
};

export default configureStore;
